export default __webpack_public_path__ + "static/media/error.a1182b28.svg";